import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { featureFlags } from '@/lib/env';

import { SelfReportConfirmationSearchSchema } from './self-report-confirmation/-zod-schema';

export const Route = createFileRoute(
  '/_staff/it-operation-core/self-report-confirmation',
)({
  beforeLoad: () => {
    if (!featureFlags.check('ENABLE_IN_HOUSE_OPERATION_PACKAGE')) {
      throw redirect({ to: '/it-operation-core/packages' });
    }
  },
  validateSearch: zodValidator(SelfReportConfirmationSearchSchema),
});
